import { BloodDrawConfirmationType } from '@nkr/enums/blood-draw-confirmation-type';

export interface IBloodDrawConfirmationContract {
    id: number,
    swapNumber: string,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    rdnCenterId?: number,
    rdnCenterAlias?: string,
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenterAlias: string,
    targetSurgeryDate: string,
    scheduledBloodDrawDate: string,
    confirmationType: BloodDrawConfirmationType,
    bloodDrawCompleted?: boolean
}
